import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import AppsIcon from '@mui/icons-material/Apps';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupIcon from '@mui/icons-material/Group';
import PollIcon from '@mui/icons-material/Poll';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { lazy } from "react";

const iconStyle = { fontSize: '1.5rem', margin: '0px', padding: '0px' };
export const MENU_ICONS = {
    "apps": <AppsIcon style={iconStyle} />,
    "dashboard": <DashboardIcon style={iconStyle} />,
    "business": <BusinessIcon style={iconStyle} />,
    "group": <GroupIcon style={iconStyle} />,
    "calendar_month": <CalendarMonthIcon style={iconStyle} />,
    "punch_clock": <PunchClockIcon style={iconStyle} />,
    "request_page": < DescriptionIcon style={iconStyle} />,
    "poll": <PollIcon style={iconStyle} />,
    "description": <DescriptionIcon style={iconStyle} />,
    "add_business": <RequestPageIcon style={iconStyle} />,
    "finance": <AccountBalanceWalletIcon style={iconStyle} />,
    "core_hr": <AddBusinessIcon style={iconStyle} />,
    "setting": <SettingsIcon style={iconStyle} />
}

const Overview = lazy(() => import("./Pages/Overview"));
const Subscription = lazy(() => import("./Pages/Subscription"));
const Plans = lazy(() => import("./Pages/Plans"));
const Wallet = lazy(() => import("./Pages/Wallet"));
const Invoices = lazy(() => import("./Pages/Invoices"));
const Consumption = lazy(() => import("./Pages/Consumption"));
const PaymentMethod = lazy(() => import("./Pages/PaymentMethod"));
const PaymentStatus = lazy(() => import("./Pages/PaymentMethod/PaymentStatus"));
const AppList = lazy(() => import("./Pages/AppList/AppList"));
const MySubscriptions = lazy(() => import("./Pages"));


export const fixedRoutes = [
    { url: '/apps', menu_layout: "APPS" },
    { url: '/my-subscription', menu_layout: "my_subscriptions" }
    // { url: '/payment/payment-status/:id', component: "payment_status" },

]

export const routeNames = {
    APPS: AppList,
    overview: Overview,
    subscription: Subscription,
    plans: Plans,
    wallet: Wallet,
    invoices: Invoices,
    consumption: Consumption,
    payment_method: PaymentMethod,
    payment_status: PaymentStatus,
    my_subscriptions: MySubscriptions
}


export default routeNames;